import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
})
export class VerifyEmailComponent implements OnInit {
  confirmationEmailMessage: string;
  verifyEmail: string;
  resendVerificationEmail: string;
  goBackToSignIn: string;
  verifyEmailLabel: string;
  signInLabel: string;

  constructor(public authService: AuthService, private themeService: ThemeService) {
    this.themeService.getAuthorizationSettings().once('value', snapshot => {
      this.confirmationEmailMessage = snapshot.val().confirmation_email_message;
      this.verifyEmail = snapshot.val().verify_email;
      this.resendVerificationEmail = snapshot.val().resend_verification_email;
      this.goBackToSignIn = snapshot.val().go_back_to_sign_in;
      this.verifyEmailLabel = snapshot.val().verify_email_label;
      this.signInLabel = snapshot.val().sign_in_label;
    });
  }

  ngOnInit() {}

}
